import * as z from 'zod';

export const DealOriginSchema = z.object({
    "id": z.number(),
    "is_active": z.boolean(),
    "name": z.string()
});

export const DealOriginPartialSchema = DealOriginSchema.partial();
export type DealOriginPartial = z.infer<typeof DealOriginPartialSchema>;
export type DealOrigin = z.infer<typeof DealOriginSchema>;

export function newDealOrigin(data: unknown) {
    if (data === null || data === undefined) {
        throw new Error('Payload can\'t be null or undefined.');
    }

    if (typeof data !== 'object') {
        throw new Error('Payload has to be an object');
    }

    return {
        ...DealOriginSchema.parse({...data})
    };
}

export function parseDealOrigin(data: any, partial = false) {
    if (!partial) {
        return {
            ...DealOriginSchema.parse(data)
        };
    }
    else if (data === null || data === undefined) {
        throw new Error('Payload can\'t be null or undefined.');
    }
    else if (typeof data !== 'object') {
        throw new Error('Payload has to be an object');
    }
    else if (Object.keys(data).length === 0) {
        throw new Error('Payload Object can\'t be null');
    }
    else {
        return {
            ...DealOriginPartialSchema.parse(data)
        };
    }
}
